<p-fieldset legend="Route:">
    <div class="grid">
        <div class="col-12">
            <input type="text" [(ngModel)]="value" pInputText=""/>
        </div>
        <div class="col-12 p-md-4">
            <p-dropdown [options]="items"
                        placeholder="Change Route.."
                        (onChange)="onSelectRouteChanged()"
                        [(ngModel)]="selectedRoute">
            </p-dropdown>
        </div>
    </div>

    <p-panel *ngIf="selectedRoute === ROUTE_SLIDE">
        <p-header>
            <div class="ui-helper-clearfix">
                <div class="grid">
                    <div class="col">
                        <span class="h5 bold italic">Additional Configuration</span>
                    </div>
                    <div class="col right-align">
                        <span (click)="applyImagesRoute()" class="hand bold blue">SAVE</span>
                        <!--<button type="button" label="Save Item" icon="fa fa-save" class="prime-button" pButton="" (click)="applyImagesRoute()"></button>-->
                    </div>
                </div>
            </div>
        </p-header>

        <div class="grid">
            <div class="col-10">
                Host:
                <input type="text" [(ngModel)]="imagesParam.host" placeholder="https://storage.googleapis.com"
                       pInputText style="display: inline-block;width: 80%"/>
            </div>
            <div class="col-10">
                Path:
                <input type="text" class="inline-block" [(ngModel)]="imagesParam.path"
                       placeholder="/golfdigg/img/banner_app/" pInputText style="display: inline-block;width: 80%"/>
            </div>
        </div>

        <p-fieldset legend="Images">
            <div *ngFor="let imgfile of imagesParam.files; trackBy: trackByIndex; let index = index;">
                <div class="grid">
                    <div class="col-8">
                        <input type="text" [(ngModel)]="imagesParam.files[index]" pInputText=""/>
                    </div>
                    <div class="col-4">
                        <button type="button" icon="pi pi-trash" class="ui-button ui-button-danger" pButton=""
                                (click)="deleteImage(imgfile)"></button>
                    </div>
                </div>
            </div>
            <p-footer>
                <div class="grid">
                    <div class="col"></div>
                    <div class="col-4">
                        <button type="button" icon="pi pi-plus" pButton="" (click)="addImage()"></button>
                    </div>
                </div>
            </p-footer>

        </p-fieldset>

        <div class="grid">
            <div class="col-12">
                <p-fieldset [toggleable]="true" [collapsed]="true" legend="Preview">
                    <div>
                        <p-card *ngFor="let imgfile of imagesParam.files;" class="inline-block">
                            <p-header>
                                <span class="h6">{{imgfile}}</span>
                            </p-header>
                            <img src="{{getImageURL(imgfile)}}" style="height: 200px">
                        </p-card>
                    </div>
                </p-fieldset>
            </div>
        </div>

    </p-panel>


    <div *ngIf="selectedRoute === ROUTE_WEBVIEW">
        URL:
        <input type="text" [(ngModel)]="webViewParam.url" placeholder="https://www.golfdigg.co.th" pInputText=""/>

        <div class="mt2 right-align">
            <button type="button" label="Apply" class="prime-button-sm" pButton=""
                    (click)="applyImagesRoute()"></button>
        </div>
    </div>
</p-fieldset>
